import { useState, useEffect } from "react";
import { GetStocksForSale } from 'services/stock/stock.service';
import { GetBrands } from "services/other/brand.service";
import { useSelector, useDispatch } from "react-redux";

const useItemDropdown = () => {
    const dispatch = useDispatch();
    
    const { stockList } = useSelector((state) => state.stockListForSale);
    const { brandList } = useSelector((state) => state.brandList);

    const [productDropdown, setProductDropdown] = useState([]);
    const [brandDropdown, setBrandDropdown] = useState([]);


    useEffect(() => {
        dispatch(GetStocksForSale());
        dispatch(GetBrands());
    }, []);

    return {
        productDropdown, 
        setProductDropdown, 
        brandDropdown,
        setBrandDropdown,
        stockList,
        brandList,
    };
};

export default useItemDropdown;
